export default [
  {
    path: '/settings-general',
    name: 'settings-general',
    component: () => import('@/views/settings/general.vue'),
    meta: {
      title: 'Основные настройки',
    },
  },
  {
    path: '/settings-program',
    name: 'settings-program',
    component: () => import('@/views/settings/program.vue'),
    meta: {
      title: 'Функционал программы',
    },
  },
  {
    path: '/settings-organization',
    name: 'settings-organization',
    props: true,
    component: () => import('@/views/settings/organization.vue'),
    meta: {
      title: 'Организация',
    },
  },
]
